import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash } from "@phosphor-icons/react";
import { fetchCategories, createCategory, deleteCategory } from "../../lib/api";

export default function AdminCategories() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", description: "", thumbnail: "", order: 0 });
  const reload = () => fetchCategories().then(setItems);
  useEffect(() => { reload(); }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name) return toast.error("Name required");
    await createCategory({ ...form, order: parseInt(form.order || 0) });
    setForm({ name: "", description: "", thumbnail: "", order: 0 });
    toast.success("Category created");
    reload();
  };

  return (
    <div data-testid="admin-categories-page" className="space-y-10">
      <div>
        <div className="overline text-[#B79C7B]">Taxonomy</div>
        <h1 className="font-serif text-4xl text-ivory mt-2">Categories</h1>
      </div>
      <section className="border border-[#2A2A2D] bg-[#121214] p-8">
        <form onSubmit={onSubmit} className="grid md:grid-cols-2 gap-4">
          <input className="h-11 bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 text-ivory" placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="cat-name" />
          <input className="h-11 bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 text-ivory" placeholder="Thumbnail URL" value={form.thumbnail} onChange={(e) => setForm({ ...form, thumbnail: e.target.value })} data-testid="cat-thumb" />
          <input className="h-11 bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 text-ivory" type="number" placeholder="Order" value={form.order} onChange={(e) => setForm({ ...form, order: e.target.value })} data-testid="cat-order" />
          <button type="submit" className="h-11 bg-[#8A2E2E] hover:bg-[#A33B3B] text-sm tracking-widest flex items-center justify-center gap-2" data-testid="add-cat-button"><Plus size={16} /> ADD CATEGORY</button>
          <textarea className="md:col-span-2 min-h-[80px] bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 py-3 text-ivory" placeholder="Description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} data-testid="cat-desc" />
        </form>
      </section>
      <section className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {items.map((c) => (
          <div key={c.id} className="border border-[#2A2A2D] bg-[#121214] overflow-hidden" data-testid={`cat-card-${c.slug}`}>
            <div className="aspect-[4/3] bg-[#1A1A1D] overflow-hidden">
              {c.thumbnail && <img src={c.thumbnail} alt="" className="w-full h-full object-cover" />}
            </div>
            <div className="p-4 flex items-center justify-between gap-2">
              <div className="min-w-0">
                <div className="text-ivory truncate">{c.name}</div>
                <div className="text-xs text-[#71717A] truncate">{c.slug}</div>
              </div>
              <button onClick={async () => { await deleteCategory(c.id); reload(); }} className="text-[#71717A] hover:text-[#FF3B30]" data-testid={`delete-cat-${c.id}`}><Trash size={14} /></button>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
